import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { isEvArticle } from 'site-modules/editorial/utils/ev';
import { TreehousePromotionCheck } from 'site-modules/shared/components/treehouse-promotion/treehouse-promotion-check';
import { ReadyForEvTreehouse } from 'site-modules/shared/components/ready-for-ev/ready-for-ev';
import { Experiment, Recipe } from 'site-modules/shared/components/experiment';

import './article-treehouse-promotion.scss';

export function ArticleTreehousePromotion({ className, categories, slug, fallback }) {
  if (!isEvArticle({ slug, categories })) {
    return fallback;
  }

  return (
    <TreehousePromotionCheck fallback={fallback}>
      <div className={classnames('article-treehouse-promotion bg-cool-gray-90 px-1 py-1 rounded-12', className)}>
        <Experiment name="core-6520-ev-ready" showDefault>
          <Recipe name="ctrl" isDefault>
            <ReadyForEvTreehouse
              className="bg-white rounded-12 px-1_5 py-1_5 mx-auto"
              heading="Am I Ready for an EV?"
              creativeId="treehouse-promotion"
            />
          </Recipe>
          <Recipe name="chal">
            <ReadyForEvTreehouse
              className="bg-white rounded-12 px-1_5 py-1_5 mx-auto"
              heading="Am I Ready for an EV?"
              creativeId="treehouse-promotion"
              isSimpleLayout
            />
          </Recipe>
        </Experiment>
      </div>
    </TreehousePromotionCheck>
  );
}

ArticleTreehousePromotion.propTypes = {
  slug: PropTypes.string.isRequired,
  categories: PropTypes.arrayOf(PropTypes.string),
  className: PropTypes.string,
  fallback: PropTypes.node,
};

ArticleTreehousePromotion.defaultProps = {
  categories: [],
  className: null,
  fallback: null,
};
